// extracted by mini-css-extract-plugin
export default {"container":"styles_container__BZRMM","spin":"styles_spin__KlUg4","invert":"styles_invert__vZoBH","buttonLoader":"styles_buttonLoader__meWNR"};